// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"0a986062","879":"0a986062","993":"891c817e"}[chunkId] + ".chunk.css";
};